
import { motion } from "framer-motion";
import { Heart, Gift } from "lucide-react";
import { LainaCta } from "@/components/common/LainaCta";

export const WeddingCallToAction = () => {
  // Default loan parameters for the wedding loan
  const defaultLoanAmount = 15000;
  const defaultLoanTerm = 5;
  const applicationUrl = `/kilpailuta?amount=${defaultLoanAmount}&term=${defaultLoanTerm}&type=haalaina`;

  return (
    <motion.div
      initial="hidden"
      animate="visible"
      custom={7}
      variants={{
        hidden: { opacity: 0, y: 20 },
        visible: (i: number) => ({
          opacity: 1,
          y: 0,
          transition: {
            delay: i * 0.1,
            duration: 0.5,
          }
        })
      }}
      className="mb-12"
    >
      <div className="bg-gradient-to-r from-pink-600 to-pink-700 rounded-lg p-8 text-center text-white shadow-lg">
        <div className="flex justify-center space-x-4 mb-4">
          <Heart className="h-12 w-12 text-pink-200" />
          <Gift className="h-12 w-12 text-pink-200" />
        </div>
        <h2 className="text-3xl font-bold mb-4">Toteuta unelmiesi päivä</h2>
        <p className="text-lg mb-6 max-w-2xl mx-auto text-pink-100">
          Varmista, että hääpäiväsi on juuri sellainen kuin olet aina haaveillut. 
          Joustava rahoitusvaihtoehto antaa sinulle mahdollisuuden keskittyä juhlapäivän 
          suunnitteluun ilman budjettirajoituksia.
        </p>
        <LainaCta 
          to={applicationUrl}
          text="Katso lainatarjoukset"
          variant="primary"
          className="bg-white text-pink-600 hover:bg-pink-50"
          size="lg"
          dataTestId="wedding-cta-main"
        />
      </div>
    </motion.div>
  );
};
